<template>
  <div class="z-messagePanel">
    <div class="z-mark"></div>
    <div class="alertPanel flex flex-row flex-align-c" @click="close">
      <div class="messagePanel">
        <div v-if="title">
            <i class="iconfont icon-success c-green fs22" v-if="type=='success'"></i>
            <i class="iconfont icon-error c-red fs22" v-if="type=='error'"></i>
            <span class="ml3 fs22 c-grey-3">{{title}}</span>
        </div>
        <div :class="['title fs16 c-grey-6',{mt5:title}]" v-if="content">
            {{content}}
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">

  export default {
    props:[],

    data() {
      return {
        title:"", //标题
        content:"", //内容
        type:"default", //icon样式，默认没有
        time:3000 //定时默认3秒
      };
    },

    mounted(){
      let {time} = this;

      //表示有定时器
      if(time > 0){
        this.timeout ? clearTimeout(this.timeout) : "";
        this.timeout = setTimeout(()=>{
          this.close();
        },time);
      }
    },

    methods: {
      close:function(){
        if(this.timeout){
          clearTimeout(this.timeout);
        }
        this.$destroy(true);
        this.$el.parentNode.removeChild(this.$el);
      }
    },

    computed: {
      
    }
  };
</script>

<style lang="scss" scoped>
  .z-mark{
    position: fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:6666;
    background-color: rgba(0,0,0,.5);
  }

  .alertPanel{
    position:fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:9999;
    background:transparent;
  }

  .messagePanel{
    background:#fff;
    border-radius:4px;
    margin:0 auto;
    width:400px;
    max-width:85%;
    box-sizing:border-box;
    padding:15px;
    text-align:center;
  }

</style>


// WEBPACK FOOTER //
// src/components/element/message/Message.vue